@if (messages$ | async; as messages) {
    @for (message of messages; track message) {
        <bs-alert [type]="alertType" [message]="message" [title]="sitecore.quickBetMessages.BetPlaceFailedTitle" (click)="messageClick($event)" />
    }
}
